// src/util/debug.js
// Turn on with either:
//   localStorage.setItem('squid.debug','true')
// or build-time env: REACT_APP_SQUID_DEBUG=true
let fmDebug = false;

export const DEBUG_SQUID = (() => {
  try {
    return localStorage.getItem('squid.debug') === 'true'
      || process.env.REACT_APP_SQUID_DEBUG === 'true';
  } catch {
    return process.env.REACT_APP_SQUID_DEBUG === 'true';
  }
})();

// Allow FM to control debug too (e.g., from a flag)
export function setDebugFromFlags(on) {
  fmDebug = !!on;
}

export function dlog(...args) {
  if (DEBUG_SQUID || fmDebug) {
    // eslint-disable-next-line no-console
    console.log('[squid-ui]', ...args);
  }
}